<template>
    <div ref="top3" class="slider-item slider-item--top3">
        <h2 ref="title" class="slider-item__title" v-html="title" />
        <ol class="top3-list">
            <li v-for="item in list" :key="item.name" class="top3-list__item">
                <div class="top3-list__item-wrapper">
                    <div class="top3-list__item-container">
                        <strong>{{ item.name }}</strong>
                        <br />
                        {{ $t.__('common.labels.with') }}
                        <span> {{ item.value }} {{ getUnit(item) }} </span>
                    </div>
                </div>
            </li>
        </ol>
    </div>
</template>
<script>
import anime from 'animejs';

export default {
    name: 'Top3Slide',
    props: {
        title: {
            type: String,
            required: true,
        },
        list: {
            type: Array,
            required: true,
        },
        unit: {
            type: String,
            default: '',
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        getUnit() {
            return (item) => {
                return item.unit || this.unit;
            };
        },
    },
    watch: {
        isActive(value) {
            if (value) {
                const animatedTimeline = anime.timeline({
                    delay: 300,
                });

                animatedTimeline
                    .add({
                        targets: this.$refs.title,
                        opacity: [0, 1],
                    })
                    .add({
                        targets: this.$refs.top3.querySelectorAll('.top3-list__item'),
                        translateX: [-40, 0],
                        opacity: [0, 1],
                        delay: anime.stagger(1000),
                    });
            } else {
                this.$refs.title.removeAttribute('style');
                const items = this.$refs.top3.querySelectorAll('.top3-list__item');
                for (const item of items) {
                    item.removeAttribute('style');
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.slider-item {
    &.slider-item--top3 {
        align-items: flex-start;
        gap: 60px;
        justify-content: flex-start;
    }

    &__title {
        color: #c8d2fe;
        font-family: Patron, sans-serif;
        font-size: 48px;
        font-weight: 400;
        letter-spacing: -1px;
        margin: 0;
        opacity: 0;
    }

    .top3-list {
        counter-reset: myCounter;
        display: flex;
        flex: 1;
        flex-direction: column;
        gap: 30px;
        justify-content: center;
        list-style: none;
        margin: 0;
        padding: 0;

        &__item {
            color: var(--colors-sellsy-brand-primary-10);
            counter-increment: myCounter;
            display: flex;
            font-family: Patron, sans-serif;
            font-size: 17px;
            gap: var(--spacing-1);
            opacity: 0;

            &-wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            strong {
                color: var(--colors-sellsy-brand-primary-05);
                font-weight: 600;
            }

            &:before {
                content: '#' counter(myCounter);
                color: var(--colors-sellsy-brand-primary-20);
                flex-shrink: 0;
                font-size: 48px;
                line-height: 52px;
                width: 80px;
            }
        }
    }
}
</style>
